import React, { createContext, useContext, useState } from 'react';

const BriefContext = createContext(null);

export const BriefProvider = ({ children }) => {
  const [briefData, setBriefData] = useState(null);
  const [isComplete, setIsComplete] = useState(false);
  const [completionStatus, setCompletionStatus] = useState({
    status: 'draft',
    missing_fields: [],
  });
  const [briefId, setBriefId] = useState(null);

  const updateBriefData = (data) => {
    setBriefData(data);
  };

  const updateCompletionStatus = (status) => {
    setCompletionStatus(status);
    setIsComplete(status.is_complete || false);
  };

  const clearBriefData = () => {
    setBriefData(null);
    setIsComplete(false);
    setCompletionStatus({
      status: 'draft',
      missing_fields: [],
    });
    setBriefId(null);
  };

  return (
    <BriefContext.Provider
      value={{
        briefData,
        isComplete,
        completionStatus,
        briefId,
        updateBriefData,
        updateCompletionStatus,
        setBriefId,
        clearBriefData,
      }}
    >
      {children}
    </BriefContext.Provider>
  );
};

export const useBrief = () => {
  const context = useContext(BriefContext);
  if (!context) {
    return {
      briefData: null,
      isComplete: false,
      completionStatus: { status: 'draft', missing_fields: [] },
      briefId: null,
      updateBriefData: () => {},
      updateCompletionStatus: () => {},
      setBriefId: () => {},
      clearBriefData: () => {},
    };
  }
  return context;
};
